// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaGoogle_root__4qN1Y"};